import styled from 'styled-components';
import { Card } from 'antd';

export const LoginContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f8f9fa;
  padding: 20px;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: 
      radial-gradient(circle at 20% 50%, rgba(24, 144, 255, 0.03) 0%, transparent 50%),
      radial-gradient(circle at 80% 80%, rgba(82, 196, 26, 0.03) 0%, transparent 50%);
    pointer-events: none;
  }
`;

export const StyledCard = styled(Card)`
  width: 100%;
  max-width: 480px;
  box-shadow: 
    0 8px 24px rgba(0, 0, 0, 0.12),
    0 4px 12px rgba(0, 0, 0, 0.08);
  border-radius: 24px;
  border: 2px solid rgba(24, 144, 255, 0.1);
  position: relative;
  z-index: 1;
  background: #ffffff;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: #1890ff;
  }

  .ant-card-body {
    padding: 48px;
  }
`;

export const LogoContainer = styled.div`
  text-align: center;
  margin-bottom: 24px;
`;

export const Logo = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: #1890ff;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
`;

